import { render } from "./BaseTextarea.vue?vue&type=template&id=3ebc704a&scoped=true"
import script from "./BaseTextarea.vue?vue&type=script&lang=js"
export * from "./BaseTextarea.vue?vue&type=script&lang=js"

import "./BaseTextarea.vue?vue&type=style&index=0&id=3ebc704a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3ebc704a"
/* hot reload */
if (module.hot) {
  script.__hmrId = "3ebc704a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ebc704a', script)) {
    api.reload('3ebc704a', script)
  }
  
  module.hot.accept("./BaseTextarea.vue?vue&type=template&id=3ebc704a&scoped=true", () => {
    api.rerender('3ebc704a', render)
  })

}

script.__file = "src/components/BaseTextarea.vue"

export default script